import { useTranslation } from 'react-i18next'
import { safePolygon, useHover, useInteractions } from '@floating-ui/react'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useFloatingSelect, useThemeMode } from '../../../hooks'
import { FloatingSelectDropdown, FloatingTrigger } from '../../Floating'
import { List } from '../../List'
import { ListItem } from '../../ListItem'
import { UserMenuThemeModeArrow } from '../UserMenuThemeModeArrow'
import { UserMenuThemeModeOption } from '../UserMenuThemeModeOption'

import {
  QA_NAME_USER_THEME,
  USER_MENU_THEME_MODE_OPTIONS,
} from './UserMenuThemeMode.constants'
import { isNeedToShowUserMenuThemeModeIcons } from './UserMenuThemeMode.utils'

import * as styles from './UserMenuThemeMode.module.css'

function UserMenuThemeMode() {
  const { t } = useTranslation()

  const { changeMode, mode } = useThemeMode()

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({
      placement: FLOATING_ELEMENT_PLACEMENT.leftStart,
      shouldClampHeight: false,
    })

  const hover = useHover(context, { handleClose: safePolygon() })

  const {
    getFloatingProps: getHoverFloatingProps,
    getReferenceProps: getHoverReferenceProps,
  } = useInteractions([hover])

  function handleClick() {
    setOpen(true)
  }

  return (
    <FloatingTrigger context={context}>
      <div {...getHoverReferenceProps()}>
        <ListItem
          Icons={UserMenuThemeModeArrow}
          isActive={isOpen}
          isNeedToShowIcons={isNeedToShowUserMenuThemeModeIcons}
          qaName={QA_NAME_USER_THEME}
          text={t('Header.ThemeKey')}
          onClick={handleClick}
        />
        <FloatingSelectDropdown
          {...getHoverFloatingProps()}
          context={context}
          floatingStyles={floatingStyles}
          getFloatingProps={getFloatingProps}
          isOpen={isOpen}
          refs={refs}
        >
          <List className={styles.list}>
            {USER_MENU_THEME_MODE_OPTIONS.map(option => (
              <ListItem
                Content={UserMenuThemeModeOption}
                Icons={null}
                Preview={option.Preview}
                isChecked={option.value === mode}
                key={option.value}
                qaName={option.qaName}
                text={t(option.text)}
                value={option.value}
                onClick={changeMode}
              />
            ))}
          </List>
        </FloatingSelectDropdown>
      </div>
    </FloatingTrigger>
  )
}

export default UserMenuThemeMode
